var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-downmenu"},[_c('el-scrollbar',{staticStyle:{"height":"calc(100vh - 60px)"}},[_c('el-menu',{staticClass:"s-downmenu-main",attrs:{"default-active":"2"},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},[_c('SmallMenuItem',{attrs:{"sub-menu":_vm.menu}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }